/* unplugin-vue-components disabled */import { render } from "./refundBlock.vue?vue&type=template&id=5e135bd1&scoped=true"
const script = {}

import "./refundBlock.vue?vue&type=style&index=0&id=5e135bd1&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e135bd1"]])

export default __exports__